import React, { createContext, useContext, useEffect, useState } from 'react';
import { themes } from '../config/themes';

const TEXT_SCALE_VALUES = {
    normal: 1,
    large: 1.125,
};

const ThemeContext = createContext(null);

export function ThemeProvider({ children }) {
    const [themeName, setThemeName] = useState(
        () => localStorage.getItem('sitetheme') || 'light'
    );
    const [textScale, setTextScaleState] = useState(
        () => localStorage.getItem('textscale') || 'normal'
    );

    const theme = themes[themeName] || themes.light;

    useEffect(() => {
        const scale = TEXT_SCALE_VALUES[textScale] ?? 1;
        document.documentElement.dataset.textScale = textScale;
        document.documentElement.style.setProperty('--text-scale', String(scale));
    }, [textScale]);

    const toggleTheme = () => {
        const next = themeName === 'light' ? 'dark' : 'light';
        setThemeName(next);
        localStorage.setItem('sitetheme', next);
    };

    const setTextScale = (scale) => {
        setTextScaleState(scale);
        localStorage.setItem('textscale', scale);
    };

    const toggleTextScale = () => {
        setTextScale(textScale === 'large' ? 'normal' : 'large');
    };

    return (
        <ThemeContext.Provider value={{ theme, themeName, toggleTheme, textScale, setTextScale, toggleTextScale }}>
            {children}
        </ThemeContext.Provider>
    );
}

export function useTheme() {
    const ctx = useContext(ThemeContext);
    if (!ctx) throw new Error('useTheme must be used within ThemeProvider');
    return ctx;
}
